/**
 * @fileoverview Search dialog for mobile devices, providing a modal search
 * input when the header search field is hidden.
 */

import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useNavigate } from 'react-router';
import { SearchField } from '@/shared/components';

export interface SearchDialogProps {
  open: boolean;
  onClose: () => void;
}

export function SearchDialog({ open, onClose }: SearchDialogProps) {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query.trim())}&mode=hybrid`);
      onClose();
      setQuery('');
    }
  };

  const handleClose = () => {
    onClose();
    setQuery('');
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Search Notes</DialogTitle>
      <DialogContent>
        <SearchField
          value={query}
          onChange={setQuery}
          onSubmit={handleSubmit}
          placeholder="Search notes..."
          fullWidth
          autoFocus
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!query.trim()}>
          Search
        </Button>
      </DialogActions>
    </Dialog>
  );
}
